import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

export const INCOMPLETE_ORDER_EXPORT_COLUMNS = [
    {
        title: "Número de pedido",
        field: "order_num",
    },
    {
        title: "Nombre",
        field: "name",
    },
    {
        title: "Correo electrónico",
        field: "email",
    },
    {
        title: "Teléfono",
        field: "address.tel",
    },
    {
        title: "Total del carrito",
        field: "total",
    },
    {
        title: "Método de pago",
        field: "payment_method",
    },
    {
        title: 'Estatus de pago',
        field: 'payment_status',
        filtering: true
    },
    {
        title: 'Detalles PayPal',
        field: 'payment.paypal_errors',
    },
    {
        title: 'Detalles MercadoPago',
        field: 'payment.mercadopago_errors',
    },
    {
        title: 'Detalles Openpay',
        field: 'payment.openpay_errors',
    },
    {
        title: 'Fecha',
        field: 'orderDate.formattedDate',
    }
];

export const INCOMPLETE_ORDER_TABLE_COLUMNS = [
    {
        title: "Número de pedido",
        field: "order_num",
        filtering: true
    },
    {
        title: "Nombre",
        field: "name",
        filtering: false
    },
    {
        title: "Correo electrónico",
        field: "address.email",
        filtering: false
    },
    {
        title: "Total del carrito",
        field: "total",
        filtering: false
    },
    {
        title: "Método de pago",
        field: "payment_method",
        filtering: true
    },
    {
        title: 'Fecha',
        field: 'orderDate.formattedDate',
        filtering: false
    },
    {
        title: "Carrito abandonado",
        field: "hasAbandonedCart",
        filtering: false,
        render: rowData => (
            rowData.hasAbandonedCart ? (
                <ProductionQuantityLimitsIcon style={{ color: '#f44336' }} />
            ) : (
                <ShoppingCartIcon style={{ color: '#4caf50' }} />
            )
        )
    },
];